import { Chip } from '@frameio/vapor';
import TEXT from './generated/TEXT/NewChip';

TEXT.DEFINE({
  /** Label text for new feature chip */
  label: 'New',
});

export const NewChip = () => {
  return (
    <Chip color="purple" size="small" variant="ghost">
      {TEXT.label}
    </Chip>
  );
};
